import { SITE_BETA_DISCLAIMER } from '../constants/siteDisclaimer';
import './BetaPriceNotice.css';

/**
 * @param {{
 *   dismissed: boolean;
 *   onDismiss: () => void;
 * }} props
 */
export function BetaPriceNotice({ dismissed, onDismiss }) {
  if (dismissed) {
    return null;
  }

  return (
    <div className="beta-price-notice" role="status">
      <div className="beta-price-notice__inner">
        <span className="beta-price-notice__badge">BETA</span>
        <p className="beta-price-notice__text">{SITE_BETA_DISCLAIMER}</p>
        <button
          type="button"
          className="beta-price-notice__close"
          aria-label="Dismiss price accuracy notice"
          onClick={onDismiss}
        >
          ×
        </button>
      </div>
    </div>
  );
}
